export default "__VITE_ASSET__fe67029e__"